import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/portland")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Portland, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Portland & San Patricio County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Portland, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Portland and San Patricio County.",
      keywords: "awnings Portland, awning company Portland, custom awnings Portland, sail shades Portland, patio covers Portland, pergola covers Portland, metal awnings Portland, canvas awnings Portland, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Portland", "San Patricio County"),
  }),
  component: () => <CityHomePage city="Portland" region="San Patricio County" />,
});
